export class SortField {
  constructor(name = "", sortAscending = true) {
    this.Name = name;
    this.SortAscending = sortAscending;
  }
}
